import React from 'react';
import { FieldLabel } from './FieldLabel';

export function StringField({ k, value, onChange, isTextarea }) {
  const Tag = isTextarea ? 'textarea' : 'input';
  return (
    <div>
      <FieldLabel k={k}>{k}</FieldLabel>
      <Tag
        data-testid={`field-${k}`}
        rows={isTextarea ? 3 : undefined}
        type={isTextarea ? undefined : 'text'}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        className={`input-bare ${isTextarea ? 'resize-none' : ''}`}
      />
    </div>
  );
}

export function NumberField({ k, value, onChange }) {
  return (
    <div>
      <FieldLabel k={k}>{k}</FieldLabel>
      <input
        data-testid={`field-${k}`}
        type="number"
        value={value ?? 0}
        onChange={(e) => onChange(Number(e.target.value))}
        className="input-bare"
      />
    </div>
  );
}

export function BoolField({ k, value, onChange }) {
  return (
    <label className="flex items-center justify-between bg-bg-secondary border border-line rounded-md px-4 py-3 cursor-pointer">
      <span className="text-sm text-ink font-mono">{k}</span>
      <input
        type="checkbox"
        data-testid={`field-${k}`}
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
        className="w-5 h-5 accent-acid"
      />
    </label>
  );
}
